import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { MwUserAccessService } from '../../../auth/services/user-access.service';

@Injectable()
export class UserActionGuard implements CanActivateChild {
  constructor(
    private readonly router: Router,
    private readonly userAccessService: MwUserAccessService
  ) {}

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const actions: string[] = route.data['action'] || [];

    if (route.url[0]?.path === 'unauthorized') {
      return of(true);
    }

    if (actions.length > 0) {
      return this.userAccessService.hasAccess(actions).pipe(
        map((hasAccess) => {
          if (!hasAccess) {
            this.router.navigate(['/unauthorized']);
            return false;
          }

          return true;
        })
      );
    }
    return of(true);
  }
}
